var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTulipwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    className: "nav__logo",
    viewBox: "0 0 126 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "nav__logo-text",
    d: "M53.927 31.3709V13.5602H59.757L60.136 10.3975H44.1035V13.5602H50.0501V31.3709H53.927ZM71.8542 31.6332C76.562 31.6332 79.1417 29.5198 79.1417 24.5498V10.3975H75.3377V24.4915C75.3377 26.8963 74.8421 28.587 71.621 28.587H70.7611C67.5401 28.587 67.0154 26.8963 67.0154 24.4915V10.3975H63.2404V24.5498C63.2404 29.5198 65.8202 31.6332 70.5279 31.6332H71.8542ZM98.0309 31.3709V28.2372H88.1636V10.3975H84.3887V31.3709H98.0309ZM105.872 31.3709V10.3975H102.024V31.3709H105.872ZM115.215 31.3709V23.136H119.412C124.062 23.136 126 21.5619 126 17.685V16.1109C126 11.7384 124.266 10.3975 119.237 10.3975H111.367V31.3709H115.215ZM122.123 17.5684C122.123 19.4485 121.657 20.0024 118.961 20.0024H115.142V13.4728H118.961C121.715 13.4728 122.123 14.1141 122.123 16.1109V17.5684Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3134 10.5293L16.7841 21.0428L6.25488 10.5293L16.7998 0L27.3134 10.5293Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5679 9.55469V24.4371L18.6855 39.3195V24.4371L33.5679 9.55469Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8824 24.4183V39.3007L0 24.4183V9.53589L14.8824 24.4183Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTulipwhite);
export default __webpack_public_path__ + "static/media/tulipwhite.436b732a07fcad61f5a1ba995ff07a44.svg";
export { ForwardRef as ReactComponent };